/**
 * Legacy product-store presentation adapter.
 *
 * Product discovery is owned by the bounded item feed and product mutations by
 * itemAuthorityService. This module keeps historical getters/actions stable for
 * compatibility while never querying the raw products/custom-orgs collections.
 */

export default {
  state: {
    products: [],
    product: null,
    loading: false,
    lastVisibleProduct: null,
    allowedOrgs: [],
  },
  getters: {
    products: (state) => state.products,
    product: (state) => state.product,
    lastVisibleProduct: (state) => state.lastVisibleProduct,
  },
  actions: {
    async fetchAllowedOrganisations({ commit }) {
      commit("SET_ALLOWED_ORGANISATIONS", []);
      return [];
    },
    async fetchProducts({ commit }, { refresh = false, isInitial = false } = {}) {
      commit("SET_LOADING", true);
      if (refresh) commit("SET_LAST_VISIBLE_PRODUCT", null);
      if (refresh || isInitial) commit("SET_PRODUCTS", []);
      commit("SET_LOADING", false);
      return { items: [], nextCursor: null, hasMore: false };
    },
    async fetchProduct({ commit }) {
      commit("SET_LOADING", true);
      commit("SET_PRODUCT", null);
      commit("SET_LOADING", false);
      return null;
    },
    clearProduct({ commit }) {
      commit("CLEAR_PRODUCT");
    },
  },
  mutations: {
    SET_ALLOWED_ORGANISATIONS(state, allowedOrgs) {
      state.allowedOrgs = allowedOrgs;
    },
    SET_PRODUCTS(state, products) {
      state.products = products;
    },
    ADD_PRODUCTS(state, products) {
      state.products = [...state.products, ...products];
    },
    SET_PRODUCT(state, product) {
      state.product = product;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_LAST_VISIBLE_PRODUCT(state, product) {
      state.lastVisibleProduct = product;
    },
    CLEAR_PRODUCT(state) {
      state.product = null;
    },
  },
};
